
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { envVariables } from "../../../../helpers";
import { AlertScreen } from "../../components/AlertScreen";
import { useEncubadoraStore } from "../../../../store";

const paginado = Number( envVariables.REACT_APP_PAGINADO);




export const TablaListIncubadora = ({ data, chagePage, page }) => {


    const navigate = useNavigate();
    const { totalEncubadora } = useEncubadoraStore();



    const handleEditarIncubadora = (id) => {
        navigate(`/admin/encuba/${id}/edit`)
    }


    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'25%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'21%'}}>EMAIL</TableCell>
                                <TableCell sx={{width:'18%'}}>NIT</TableCell>
                                <TableCell sx={{width:'18%'}}>TELEFONO</TableCell>
                                <TableCell sx={{width:'18%'}}>CIUDAD</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map( ( encuba ) => (
                            <TableRow key={ encuba.id } onClick={ () => handleEditarIncubadora(encuba.id) } sx={{cursor:'pointer'}}>
                                <TableCell>{ encuba.nombre }</TableCell>
                                <TableCell>{ encuba.email }</TableCell>
                                <TableCell>{ encuba.nit }</TableCell>
                                <TableCell>{ encuba.telefono }</TableCell>
                                <TableCell>{ encuba?.ciudad?.name }</TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalEncubadora / paginado)} disabled={Math.ceil(totalEncubadora / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay galpones creados por el momento..."/>
        }
        </>
    )
}
